<div class="background" fxLayoutAlign="center center" fxLayout="row wrap">
  <div>
    <span class="bold">Copyright ©️ 2022,</span>
    <span class="normal">NABEL Co.,Ltd. All rights reserved.</span>
  </div>
  <span class="fill-remaining-space"></span>
  <div>
    <a routerLink="securitypolicy">セキュリティポリシー</a>
    <span class="divider"></span>

    <a routerLink="privacypolicy">プライバシーポリシー</a>
  </div>
</div>
